import { useRef, useState } from "react";
import { api, formatApiError, BACKEND_URL } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Upload, ExternalLink } from "lucide-react";

export function HomeworkDocs({ hw, onUpdated }) {
  const [tab, setTab] = useState("exam");
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);
  const url = tab === "exam" ? hw.file_url : hw.solution_url;
  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try {
      const { data } = await api.post(`/homework/${hw.id}/${tab === "exam" ? "file" : "solution"}`, fd);
      toast.success(tab === "exam" ? "Exam PDF replaced. Existing attempts kept." : "Solutions PDF saved.");
      onUpdated(data);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); if (inputRef.current) inputRef.current.value = ""; }
  };
  return (
    <div className="ember-card mb-5 overflow-hidden p-0" data-testid="homework-docs">
      <div className="flex flex-wrap items-center gap-2 border-b border-[#F1EEFA] p-3">
        {[["exam", "Exam PDF"], ["solutions", "Solutions"]].map(([k, l]) => (
          <button key={k} type="button" onClick={() => setTab(k)} data-testid={`docs-tab-${k}`}
            className={`rounded-lg px-3 py-1.5 text-sm font-bold transition-colors ${tab === k ? "bg-[#4B2BB8] text-white" : "text-[#4B2BB8] hover:bg-[#F3F0FF]"}`}>{l}</button>
        ))}
        <div className="ml-auto flex items-center gap-2">
          {url && <a href={`${BACKEND_URL}${url}`} target="_blank" rel="noreferrer" data-testid="docs-open-tab" className="inline-flex items-center gap-1 text-xs font-bold text-[#4B2BB8] hover:underline"><ExternalLink className="h-3.5 w-3.5" /> Open in new tab</a>}
          <input ref={inputRef} type="file" accept=".pdf,application/pdf" className="hidden" data-testid="docs-file-input" onChange={(e) => upload(e.target.files?.[0])} />
          <Button size="sm" variant="outline" disabled={busy} onClick={() => inputRef.current?.click()} data-testid="docs-replace-btn" className="h-8 rounded-lg text-xs font-bold">
            <Upload className="mr-1 h-3.5 w-3.5" /> {busy ? "Uploading…" : url ? `Replace ${tab === "exam" ? "exam PDF" : "solutions"}` : `Add ${tab === "exam" ? "exam PDF" : "solutions"}`}
          </Button>
        </div>
      </div>
      {url
        ? <iframe key={url} title={tab} src={`${BACKEND_URL}${url}#toolbar=1&view=FitH`} className="h-[60vh] w-full" data-testid={tab === "exam" ? "review-pdf" : "review-solutions-pdf"} />
        : <div className="p-8 text-sm text-[#948EAB]" data-testid="docs-empty">{tab === "exam" ? "No exam document attached." : "No solutions attached yet. Students see solutions after they submit."}</div>}
    </div>
  );
}
